import { useSelector } from 'react-redux';

import { updateDriverDetails } from '@/modules/driver/actions/async/updateDriverDetails';
import { updateOwnDriverInfo } from '@/modules/driver/actions/async/updateOwnDriver';
import { getCurrentDriver, getMyDriver } from '@/modules/driver/store/selectors';

import { TUploadScope } from './config';

const useDriverTarget = (scope: TUploadScope) => {
  const myDriver = useSelector(getMyDriver);
  const currentDriver = useSelector(getCurrentDriver);

  return scope === 'myDriver'
    ? { driver: myDriver, updateDriver: updateOwnDriverInfo }
    : { driver: currentDriver, updateDriver: updateDriverDetails };
};

export { useDriverTarget };
